import React from 'react';
import RollingLeadForm from '@/components/LeadForm/RollingLeadForm';

interface FullWidthGuideFormSectionProps {
  cid: string;
}

const FullWidthGuideFormSection = (props: FullWidthGuideFormSectionProps) => {
  return (
    <div className="flex flex-col items-center">
      <h1 className="text-3xl font-bold text-center capitalize">
        Get a custom home solar quote.
      </h1>
      <div className="rounded-[2rem]  md:px-9 py-8 mt-8 mb-8 text-gray-900 bg-slate-100 w-auto mx-4 md:w-1/2">
        <RollingLeadForm cid={props.cid} />
      </div>
    </div>
  );
};

export default FullWidthGuideFormSection;
